if (!customElements.get('cjs-clean-menu')) {
  customElements.define('cjs-clean-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const disclosures = [...this.querySelectorAll('.cjs-menu__disclosure')];
      const close = except => disclosures.forEach(item => { if (item !== except) item.open = false; });
      for (const item of disclosures) {
        item.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.timer);
          close(item);
          item.open = true;
        }, {signal});
        item.addEventListener('pointerleave', () => {
          this.timer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 140);
        }, {signal});
        item.addEventListener('toggle', () => { if (item.open) close(item); }, {signal});
      }
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const open = disclosures.find(item => item.open);
          close();
          open?.querySelector('summary').focus();
          event.preventDefault();
        }
      }, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => { if (!this.contains(document.activeElement)) close(); }), {signal});
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target) || event.target.classList?.contains('cjs-menu__scrim')) close(); }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
  });
}
